import React from "react";

import { FiX, FiCircle, FiFileText } from "react-icons/fi";
import Languages from "../libs/Languages.json";

import { ReactComponent as HomeLight } from "../img/home_light.svg";
import { ReactComponent as HomeDark } from "../img/home_dark.svg";

const darkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;

const Tab = ({ id, dragover, name, path, active, onClick, onDragStart, onDrop, onDragEnd, editing, dismissable = true, onDismiss }) => {
  let color = darkMode ? "#ddd" : "#333";
  try {
    const ext = name.split(".")[name.split(".").length - 1];
    color = Languages.find((item) => item.extensions.includes(ext)).color[darkMode ? 1 : 0];
  } catch {}

  let className = "relative text-xs py-2 px-3 border-r border-white dark:border-black text-black dark:text-white cursor-pointer select-none flex items-center ";
  if (active) {
    className += "bg-white dark:bg-black";
  } else {
    className += "hover:bg-blue-100";
  }

  return (
    <div
      style={{ WebkitAppRegion: "no-drag" }}
      data-role='tab'
      data-active={active ? "true" : "false"}
      draggable={id > 0}
      className={className}
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onDragStart={onDragStart}
      onDrop={onDrop}
      onMouseDown={onClick}
      title={!dismissable ? name : path.toLowerCase().replace("c:/pub/", "")}>
      <span className='flex items-center justify-center'>
        {!dismissable ? (
          darkMode ? (
            <HomeDark className='h-3.5' />
          ) : (
            <HomeLight className='h-3.5' />
          )
        ) : (
          <>
            <FiFileText style={{ color }} />
            &nbsp;{name}
          </>
        )}
      </span>
      {dismissable && (
        <div data-role='actions' className='relative m-4'>
          {dismissable && (
            <a
              className='absolute top-[-12px] left-0 h-6 w-6 bg-white dark:bg-black text-black dark:text-white flex items-center justify-center rounded-lg hover:bg-black-200 dark:hover:bg-black-800 transition-all'
              data-action='dismiss'
              onClick={onDismiss}>
              <FiX />
            </a>
          )}
          {editing && (
            <a
              className='absolute top-[-12px] left-0 h-6 w-6 bg-white dark:bg-black text-black dark:text-white flex items-center justify-center rounded-lg hover:opacity-0'
              data-action='editing'
              onClick={onDismiss}>
              <FiCircle className='text-[8px] fill-black-800 dark:fill-black-200' />
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default Tab;
